import React from 'react';
import Login from './Login';
import { PublicLayout } from './PublicLayout';
import LoginFailPage from './LoginFail';
import { Switch, Route, Redirect } from '../../externals/routing';
import { useLanguage } from '../../externals/language';

export const PublicArea = () => {
  const [, language] = useLanguage();

  return (
    <PublicLayout>
      <Switch>
        <Route>
          <Route
            exact
            path="/"
            render={() => <Redirect to={language('/login')} />}
          />
          <Switch>
            <Route exact path={language('/login')} component={Login} />
            <Route
              exact
              path={language('/login-failed')}
              component={LoginFailPage}
            />
            <Route component={Login} />
          </Switch>
        </Route>
      </Switch>
    </PublicLayout>
  );
};
